// Small fetch helper for the HR side of the face module (uses the normal employee token).
export const BASE = 'https://fotileams.com/api';

export class ApiError extends Error {
  constructor(status, body) { super((body && body.error) || `Request failed (${status})`); this.status = status; this.body = body || {}; }
}

export async function hr(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${BASE}/face${path}`, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (res.status === 401) window.dispatchEvent(new CustomEvent('app:logout', { detail: { reason: 'Session expired - please log in again' } }));
  if (!res.ok) throw new ApiError(res.status, data);
  return data;
}
